<template>
  <div>
    <!-- Page header -->
    <CCard class="mb-4">
      <CCardBody class="p-4">
        <CButton color="link" class="px-0 mb-2" @click="cancel">
          <CIcon name="cil-arrow-left" /> Vendors
        </CButton>
        <h1 class="h4 mb-1 font-weight-bold">{{ pageTitle }}</h1>
        <p class="text-muted mb-0">
          {{ isEdit ? "Update this vendor's contact, address and bank details" : "Add a supplier you buy from, so you can pick them on bills and purchase orders" }}
        </p>
      </CCardBody>
    </CCard>

    <!-- Load failed -->
    <CCard v-if="loadError">
      <CCardBody class="text-center py-5">
        <CIcon name="cil-warning" size="2xl" class="text-danger mb-3" />
        <h2 class="h5">Couldn't load this vendor</h2>
        <p class="text-muted mb-3">Check your connection and try again.</p>
        <CButton color="primary" @click="resetObj">
          <CIcon name="cil-reload" /> Try again
        </CButton>
      </CCardBody>
    </CCard>

    <CCard v-else>
      <CCardBody>
        <div v-if="loading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading</span>
          </div>
          <p class="mt-3 text-muted mb-0">Loading vendor…</p>
        </div>
        <CRow v-else form>
          <CCol md="6">
            <h2 class="h6 font-weight-bold mb-3">Vendor</h2>
            <CInput
              ref="nameInput"
              label="Name *"
              v-model="obj.name"
              placeholder="e.g. Supplier Sdn Bhd"
              :is-valid="nameValid"
              invalid-feedback="Enter the vendor's name"
              @blur="touched.name = true"
            />
            <CInput label="Contact name" v-model="obj.contactName" />
            <CInput label="Contact email" type="email" v-model="obj.contactEmail" />
            <CInput label="Contact phone" type="tel" v-model="obj.contactPhone" />

            <h2 class="h6 font-weight-bold mb-3 mt-4">Bank details</h2>
            <CInput label="Bank name" v-model="obj.bankName" />
            <CInput label="Bank account name" v-model="obj.bankAccountName" />
            <CInput label="Bank account number" inputmode="numeric" v-model="obj.bankAccountNo" />
          </CCol>
          <CCol md="6">
            <h2 class="h6 font-weight-bold mb-3">Address</h2>
            <CTextarea
              label="Address"
              placeholder="e.g. No. 123, Jalan Example, Taman Example"
              rows="4"
              v-model="obj.address"
            />
            <CRow form>
              <CCol sm="6">
                <CInput label="City" v-model="obj.city" />
              </CCol>
              <CCol sm="6">
                <CInput label="Postcode" inputmode="numeric" v-model="obj.postcode" />
              </CCol>
              <CCol sm="6">
                <CInput label="State" v-model="obj.state" />
              </CCol>
              <CCol sm="6">
                <CInput label="Country" v-model="obj.country" />
              </CCol>
            </CRow>
            <CInput label="Phone" type="tel" v-model="obj.phone" />
            <CInput label="Website" v-model="obj.website" />
          </CCol>
        </CRow>
      </CCardBody>
      <CCardFooter class="d-flex justify-content-between">
        <CButton color="light" :disabled="saving" @click="cancel">Cancel</CButton>
        <CButton color="primary" :disabled="saving || loading" @click="submit">
          <span v-if="saving" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
          {{ isEdit ? "Save" : "Add vendor" }}
        </CButton>
      </CCardFooter>
    </CCard>
  </div>
</template>

<script>
import VendorApi from "@/lib/vendorApi";

export default {
  name: "Vendor",
  data: () => {
    return {
      obj: {},
      loading: false,
      loadError: false,
      saving: false,
      submitted: false,
      touched: { name: false },
      api: new VendorApi(),
    };
  },
  mounted() {
    this.resetObj();
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id;
    },
    pageTitle() {
      if (!this.isEdit) return "Add vendor";
      return this.obj.name || "Vendor";
    },
    nameValid() {
      if (!this.touched.name && !this.submitted) return null;
      return !!(this.obj.name && String(this.obj.name).trim()) || false;
    },
  },
  methods: {
    cancel() {
      this.$router.push({ path: "/tenants/VendorList" });
    },
    resetObj() {
      var self = this;
      self.loadError = false;
      if (self.$route.params.id) {
        self.loading = true;
        self.api
          .get(self.$route.params.id)
          .then((response) => {
            self.obj = response.result || {};
            self.loading = false;
          })
          .catch((err) => {
            console.error("Load vendor failed", err);
            self.loading = false;
            self.loadError = true;
          });
      } else {
        self.obj = self.getEmptyObj();
      }
    },
    onSubmit() {
      var self = this;
      const creating = !self.obj.id;
      const request = creating ? self.api.create(self.obj) : self.api.update(self.obj);
      self.saving = true;
      request
        .then(() => {
          self.saving = false;
          self.$toast.success(creating ? "Vendor added" : "Vendor saved");
          self.$router.push({ path: "/tenants/VendorList" });
        })
        .catch(({ data } = {}) => {
          self.saving = false;
          self.$toast.error(
            "Couldn't save the vendor. " + helper.getErrorMessage(data, "Please try again.")
          );
        });
    },
    getEmptyObj() {
      return {};
    },
    submit() {
      this.submitted = true;
      if (!this.nameValid) {
        this.$nextTick(() => {
          const input = this.$refs.nameInput && this.$refs.nameInput.$el.querySelector("input");
          if (input) input.focus();
        });
        return;
      }
      this.onSubmit();
    },
  },
};
</script>
